import { styled } from "styled-components";

export const Row = styled.div`
  display: flex;
  width: 100%;
  gap: 16px;
`;

export const Column = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 16px;
`;

export const ReportPrintComponent = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 40px;

  .title {
    font-weight: 700 !important;
    font-size: 25px;
  }

  /* garante que a página role */
  min-height: 100vh;

  .sec2 {
    display: flex;
    width: 100%;
    margin-top: 70px;

    /* tira o height fixo */
    min-height: 200px; /* opcional: só para não colapsar vazia */

    .full {
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 16px;
      box-sizing: border-box;
    }
    .border {
      border: 1px solid #cecece;
      border-radius: 2px;
      padding: 8px 16px;
    }

    .width-20 {
      width: 20%;
    }

    .width-40 {
      width: 40%;
      margin-top: 30px;
    }
  }

  .sec1 {
    display: flex;
    width: 100% !important;
    justify-content: space-between;
    margin-top: 70px;

    .sec1-1 {
      width: 48% !important;
    }

    .sec1-2 {
      width: 42% !important;
    }

    .sec1-1,
    .sec1-2 {
      display: flex;
      flex-direction: column;
      gap: 32px;
      align-items: center;
      justify-content: center;
    }

    .empresas-item {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 140px;
      height: 80px;
      flex-direction: column;

      img {
        width: 100%;
      }
    }

    .graficos {
      width: 98%;
      display: flex;
      gap: 16px;
      align-items: center;
      justify-content: center;
    }

    .empresas {
      display: flex;
      width: 100%;
      gap: 40px;
      padding: 30px 30px;
    }

    .logo-tau {
      background-color: #ff3131;
      width: 80px;
      height: 80px;
      padding: 20px 10px 10px 10px;
      box-sizing: border-box;
      -webkit-print-color-adjust: exact !important;
      print-color-adjust: exact !important;
    }

    .logo-tau,
    .logo-jonnpo {
      border: 1px solid #ccc;
      border-radius: 2px;
      width: 80px;
    }

    .item {
      display: flex;
      flex-direction: column;
      gap: 8px;
      width: 100%;

      .card {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        border: 1px solid #ccc;
        border-radius: 2px;
        padding: 8px;

        .value {
          font-weight: 600;
        }
      }
    }
  }

  .sec3 {
    margin-top: 70px;
    display: flex;
    flex-direction: column;
    gap: 20px;

    .title-small {
      font-weight: 700 !important;
      font-size: 16px !important;
    }

    .anomalie-container {
      display: flex;
      flex-direction: column;
      gap: 4px;
    }

    .anomalie-info {
      display: flex;
      gap: 12px;

      border: 1px solid #cecece;
      border-radius: 2px;
      padding: 16px;
    }

    .anomalie-details {
      display: flex;
      flex-direction: column;
      gap: 8px;
      width: 30%;
    }

    .anomalie-details-item {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 8px;
      border-radius: 2px;
      gap: 12px;

      border: 1px solid #cecece;
    }

    .anomlie-images {
      margin-left: 40px;
      display: flex;
      gap: 4px;
      flex-wrap: wrap;
      align-items: flex-start;
    }

    .anomlie-images img {
      object-fit: cover;
      border-radius: 2px;
    }

    /* primeira imagem grande */
    .anomlie-images img:first-child {
      width: 300px;
      height: 165px;
    }

    /* demais menores */
    .anomlie-images img:not(:first-child) {
      width: 100px;
      height: 75px;
    }
  }
`;
